import { useState } from 'react';
import { IconButton, Popover, Slider, Box } from '@mui/material';
import { VolumeUp, VolumeOff } from '@mui/icons-material';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';

export default function AudioVolumeControl() {
  const { volume, setVolume, currentEpisode } = useAudioPlayer();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleVolumeChange = (event, newValue) => {
    setVolume(newValue / 100);
  };

  const open = Boolean(anchorEl);
  const disabled = !currentEpisode;

  return (
    <>
      <IconButton
        onClick={handleClick}
        disabled={disabled}
        size="small"
        aria-label={volume > 0 ? 'Adjust volume' : 'Unmute audio'}
        title={volume > 0 ? 'Adjust volume' : 'Unmute audio'}
      >
        {volume > 0 ? <VolumeUp /> : <VolumeOff />}
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Box sx={{ height: 120, py: 2, px: 1 }}>
          <Slider
            orientation="vertical"
            value={volume * 100}
            onChange={handleVolumeChange}
            aria-label="Volume"
            sx={{ height: '100%' }}
          />
        </Box>
      </Popover>
    </>
  );
}
